import { apiGet, apiPost } from "./client";
import type { AuthTokens, AuthUser } from "@ceo-cmd/shared";

interface SignInResponse {
  user: AuthUser;
  tokens: AuthTokens;
}

interface SignUpResponse {
  user: AuthUser;
  tokens: AuthTokens;
}

interface SessionResponse {
  user: AuthUser;
  tokens: AuthTokens;
}

/** Sign up with email + password. */
export async function signUp(
  email: string,
  password: string,
  name?: string,
): Promise<SignUpResponse> {
  return apiPost<SignUpResponse>("/api/auth/signup", { email, password, name });
}

/** Sign in with email + password. */
export async function signIn(
  email: string,
  password: string,
): Promise<SignInResponse> {
  return apiPost<SignInResponse>("/api/auth/login", { email, password });
}

/** Sign out — invalidate the current session server-side. */
export async function signOut(): Promise<void> {
  return apiPost<void>("/api/auth/logout");
}

/** Get current session (used on app init to check if still valid). */
export async function getSession(): Promise<SessionResponse | null> {
  try {
    return await apiGet<SessionResponse>("/api/auth/session");
  } catch {
    return null;
  }
}

/** Dev login — bypasses Cognito for local development. */
export async function devLogin(): Promise<SignInResponse> {
  return apiPost<SignInResponse>("/api/auth/dev-login");
}
